import { render } from "./home-sec4.vue?vue&type=template&id=2518c4c2"
import script from "./home-sec4.vue?vue&type=script&lang=js"
export * from "./home-sec4.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__